"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lruMemoize = require("lru-memoize");

var _lruMemoize2 = _interopRequireDefault(_lruMemoize);

var _validation = require("../../utils/validation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adFormValidator = (0, _validation.createValidator)({
  contractor: _validation.required,
  address: _validation.required,
  postal_area: _validation.required,
  postal_code: _validation.required,
  contact_person_name: _validation.required,
  contact_person_email: [_validation.required, _validation.email],
  contact_person_phone: _validation.required,
  soil_amount: [_validation.required, _validation.integer],
  soil_type_id: _validation.required,
  soil_description: _validation.required,
  // delivery_time: required,
  // validity_duration: required,
  price: _validation.number,
  ad_type: _validation.required
});
exports.default = (0, _lruMemoize2.default)(10)(adFormValidator);
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Ads/adFormValidator.js
 ** module id = 490
 ** module chunks = 0
 **/